// src/constants/privacyNotice.ts
export const privacyNotice = `
We collect and use the information submitted in this registration to operate VBS, organize children into groups and activities, contact families as needed, and coordinate volunteers.

If you register as a volunteer, your information may be used to conduct a background check when required for child safety and church policy compliance.

Personal information is used only for VBS operational and safety purposes and is not sold. All personally identifiable information will be securely deleted or destroyed after the event, except where retention is required by applicable law.
`;